export default "__VITE_ASSET__Bw6xRu8A__"